import React, { useMemo, useState } from 'react';
import { useData } from '../../store/DataContext';
import { SearchIcon } from 'lucide-react';
import { movementLabel } from './pharmacyUtils';
export function StockMovementHistory() {
  const {
    stockMovements
  } = useData();
  const [query, setQuery] = useState('');
  const movements = useMemo(() => stockMovements.filter(movement => `${movement.medicineName} ${movement.type} ${movement.actorName} ${movement.batchNumber || ''}`.toLowerCase().includes(query.toLowerCase())).sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()), [query, stockMovements]);
  return <div className="space-y-5" data-id="element-4597">
      <div data-id="element-4598">
        <h2 className="text-xl font-bold text-slate-950" data-id="element-4599">
          Stock Movement History
        </h2>
        <p className="mt-1 text-sm text-slate-500" data-id="element-4600">
          Immutable audit trail for all stock receipts, issues, adjustments,
          returns, and disposals.
        </p>
      </div>
      <section className="overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm" data-id="element-4601">
        <div className="border-b border-slate-100 p-4" data-id="element-4602">
          <div className="relative max-w-md" data-id="element-4603">
            <SearchIcon className="pointer-events-none absolute left-3 top-2.5 h-4 w-4 text-slate-400" data-id="element-4604" />
            <input aria-label="Search stock movements" value={query} onChange={e => setQuery(e.target.value)} placeholder="Search medicine, action, batch or team member" className="w-full rounded-md border border-slate-300 py-2 pl-9 pr-3 text-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500" data-id="element-4605" />
          </div>
        </div>
        <div className="overflow-x-auto" data-id="element-4606">
          <table className="min-w-full divide-y divide-slate-100" data-id="element-4607">
            <thead className="bg-slate-50" data-id="element-4608">
              <tr data-id="element-4609">
                {['Date & time', 'Medicine', 'Movement', 'Change', 'Balance', 'Reference', 'Recorded by'].map(heading => <th key={heading} className="px-5 py-3 text-left text-xs font-semibold uppercase tracking-wide text-slate-500" data-id="element-4610">
                    {heading}
                  </th>)}
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-4611">
              {movements.map(movement => <tr key={movement.id} data-id="element-4612">
                  <td className="whitespace-nowrap px-5 py-3.5 text-sm text-slate-600" data-id="element-4613">
                    {new Date(movement.createdAt).toLocaleString()}
                  </td>
                  <td className="px-5 py-3.5" data-id="element-4614">
                    <p className="font-semibold text-slate-900" data-id="element-4615">
                      {movement.medicineName}
                    </p>
                    <p className="text-xs text-slate-500" data-id="element-4616">
                      {movement.batchNumber || 'Batch auto-selected'}
                    </p>
                  </td>
                  <td className="px-5 py-3.5" data-id="element-4617">
                    <span className="rounded-full bg-slate-100 px-2 py-0.5 text-xs font-semibold text-slate-700" data-id="element-4618">
                      {movementLabel(movement)}
                    </span>
                  </td>
                  <td className={`px-5 py-3.5 text-sm font-bold ${movement.quantityDelta > 0 ? 'text-emerald-700' : 'text-red-700'}`} data-id="element-4619">
                    {movement.quantityDelta > 0 ? '+' : ''}
                    {movement.quantityDelta}
                  </td>
                  <td className="px-5 py-3.5 text-sm text-slate-700" data-id="element-4620">
                    {movement.quantityBefore} → {movement.quantityAfter}
                  </td>
                  <td className="px-5 py-3.5 text-sm text-slate-500" data-id="element-4621">
                    {movement.referenceType || 'Manual'}
                  </td>
                  <td className="px-5 py-3.5 text-sm text-slate-600" data-id="element-4622">
                    {movement.actorName}
                  </td>
                </tr>)}
              {!movements.length && <tr data-id="element-4623">
                  <td colSpan={7} className="px-5 py-14 text-center text-sm text-slate-500" data-id="element-4624">
                    No stock movements match your search.
                  </td>
                </tr>}
            </tbody>
          </table>
        </div>
      </section>
    </div>;
}